<template>
  <b-row id="medic-assistance" class="section-invert reverse-sm">
    <b-col md="12" lg="6" class="content my-auto ptop" order-lg="2">
      <h3>{{ $t("medical-assistance.title") }}</h3>
      <p class="text-info">
        {{ $t("medical-assistance.subtitle") }}
        <br /><br />
        {{ $t("medical-assistance.content") }}
      </p>
      <div class="subtitle">
        <div class="subtitle-list subtitle-list">
          <div>
            <p>
              <v-icon large>mdi-video-plus-outline</v-icon
              >{{ $t("medical-assistance.video") }}
            </p>
          </div>
          <div>
            <p>
              <v-icon large v-text="'mdi-cellphone-information'"></v-icon
              >{{ $t("medical-assistance.phone-attention") }}
            </p>
          </div>
          <div>
            <p>
              <v-icon
                large
                v-text="'mdi-file-document-multiple-outline'"
              ></v-icon
              >{{ $t("medical-assistance.written-consultation") }}
            </p>
          </div>
          <div>
            <p>
              <v-icon large v-text="'mdi-comment-processing-outline'"></v-icon
              >{{ $t("medical-assistance.chat") }}
            </p>
          </div>
          <div>
            <p>
              <v-icon large v-text="'mdi-note-plus-outline'"></v-icon
              >{{ $t("medical-assistance.electronic-prescription") }}
            </p>
          </div>
          <div>
            <b-row>
                 <b-col class="text-info">
            {{ $t("medical-assistance.safe-coms") }}
                <div class="logorec">
                    <img src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso-27001.svg" height="150px"/>
                </div>
                </b-col>

            </b-row>
          </div>
        </div>
      </div>
    </b-col>
    <b-col md="12" lg="6" class="nopadding">
      <div class="col-bg ml-lg-auto"></div>
    </b-col>
  </b-row>
</template>

<script>
  import es from '@/lang/es/public/views/primesalud.json'
  import en from '@/lang/en/public/views/primesalud.json'
  export default {
    i18n: {
      messages: {
        es,
        en,
        mx: es
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../static-appopensalud/css/public/layout.scss";
  #medic-assistance .col-bg {
    background-image: url(/static-appopensalud/img/bgs/medical-assistance.jpeg),
      linear-gradient(273deg, #ffffff96, transparent);
    background-position: center;
    background-blend-mode: overlay;
  }

  // After changing the ISO logo, we need to gain more space vertically
  p {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .section-invert .subtitle{
    margin-top: 1rem !important;
  }

  .nopadding{
    padding: 0px !important;
  }
  .logorec{
      padding-top: 1rem;
      text-align: center;
  }
  .reverse-sm {
  @include media(mobile, tablets) {
    flex-direction: column-reverse;
  }
  }
  @media (max-width: 1268px) {
    #medic-assistance
      > div.content.my-auto.col-md-12.col-lg-6
      > div
      > div
      > div
      > p {
      font-size: 1rem;
    }
  }
 // 720
  @media (min-width: 1000px) and (max-width: 1700px) {
    .ptop{
      padding-top: 8rem !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/MedicalAssistanceLanding.vue